const STORAGE_KEY = "_csc"
const COOLDOWN_MS = 5 * 60 * 1000 // 5 minutes

/**
 * Checks if the cleanup cooldown is active
 */
export const hasCleanupCooldown = (): boolean => {
  if (typeof localStorage === "undefined") return false
  const ts = localStorage.getItem(STORAGE_KEY)
  if (!ts) return false
  return Date.now() - parseInt(ts, 10) < COOLDOWN_MS
}

/**
 * Sets the cleanup cooldown timestamp
 */
export const setCleanupCooldown = (): void => {
  if (typeof localStorage === "undefined") return
  localStorage.setItem(STORAGE_KEY, Date.now().toString())
}

/**
 * Erases the cleanup cooldown, allowing cleanup to run on next page
 */
export const eraseCleanupCooldown = (): void => {
  if (typeof localStorage === "undefined") return
  localStorage.removeItem(STORAGE_KEY)
}
